<template>
    <generic-page>
        <back-to-settings />

        <div class="d-flex align-items-center justify-content-between mt-3">
            <h5 class="mb-0">
                {{ title }}
            </h5>
        </div>

        <div class="py-2">
            <div v-if="loading">
                <generic-loading />
            </div>
            <div v-else>
                <div
                    :key="interest.defaultMap.id"
                    v-for="interest in interests"
                    @click="viewProfile(interest.standardMap)"
                >
                    <user-standard-avatar
                        :standardMap="interest.standardMap"
                        :timestamp="interest.defaultMap.created"
                        :nonPrimaryPhotos="false"
                        :hideBadges="true"
                        size="small"
                        class="border-light border-top"
                    >
                    </user-standard-avatar>
                </div>
            </div>
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<script>
import BackToSettings from "@/components/setting/utility/BackToSettings";
import GenericPagination from "@/components/utility/GenericPagination";
import UserStandardAvatar from "@/components/user/UserStandardAvatar";

export default {
    data() {
        return {
            page: 1,
            hasMorePages: false,
            interests: null,
            loading: false,
        };
    },
    created() {
        this.refresh();
    },
    computed: {
        title() {
            if (this.$route.meta.mode === "inbound") {
                return this.$t("Interests Received");
            }
            if (this.$route.meta.mode === "outbound") {
                return this.$t("Interests Sent");
            }
            if (this.$route.meta.mode === "mutual") {
                return this.$t("Mutual Interests");
            }

            return "";
        },
    },
    methods: {
        viewProfile(standardMap) {
            this.$store.dispatch("profile/viewProfile", {
                userId: standardMap.id,
                profile: standardMap,
            });
        },
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
        refresh() {
            this.loading = true;

            this.api
                .post("/interest/index", {
                    page: this.page,
                    direction: this.$route.meta.mode,
                })
                .then((response) => {
                    this.interests = response?.data?.interests;
                    this.hasMorePages = response?.data?.hasMorePages;
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
    },
    components: {
        BackToSettings,
        GenericPagination,
        UserStandardAvatar,
    },
};
</script>